import React, { Component, forwardRef } from "react"
import * as endpoints from "../../api/endpoints"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { getQueryStringValue, setQueryStringValue } from "../../api/queryStringHelper"
import Spinner from "../../booking/components/spinner"
import Svg from "../_svgs/svg"
import * as dateHelper from "../../booking/helpers/date"
import * as types from "../arrivals-departures-list-search/page-types"
import axios from "axios"
import FlightsTable from "../arrivals-departures-list-search/flights-table"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import DatePicker from "react-datepicker"
import { isMobile, isIOS } from "react-device-detect"
import stickyDatepicker from "../../uiscripts/sticky-datepicker"
import { DateTime } from "luxon"

export default class ArrivalDeparturePage extends Component {
  constructor(props) {
    super(props)
    this.calendar = React.createRef()
    this.stickyCalendar = React.createRef()

    const querystring = getQueryStringValue("q") ?? ""
    const userDateQuery = getQueryStringValue("date") ?? undefined
    const userTimeQuery = getQueryStringValue("time") ?? undefined
    const currentPageJson = props.currentPageJson && JSON.parse(props.currentPageJson)
    const tabIcons = props.tabIcons && JSON.parse(props.tabIcons)
    const direction = SelectionFactoryHelper.getFromSelectionFactory(currentPageJson.pageType)
    const pageType = direction === "A" ? types.ARRIVALS : types.DEPARTURES
    const currentUrl = pageType === types.ARRIVALS ? currentPageJson.arrivalsPage : currentPageJson.departuresPage

    const dtLocale = dateHelper.luxonLocale(props.language)
    const zone = "Europe/Copenhagen"
    const cphTimeConvert = DateTime.local().setLocale(dtLocale).setZone(zone) // gets local time and changes timezone to copenhagen to get correct time
    const cphTime = cphTimeConvert.setZone("local", { keepLocalTime: true }) // locks in copenhagen time and switches back to local timezone. This ensures the time will stay CPH time when we later converts the DateTime to a JS Date object.
    let startDate = cphTime.set({ milliseconds: 0, seconds: 0, minutes: 60 }).minus({ hours: 1 })
    let minDate = startDate.minus({ days: 1 })
    let minTime = cphTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    let maxTime = cphTime.set({ hours: 23, minutes: 0, seconds: 0, milliseconds: 0 })
    let stateMinTime = minTime

    let searchDate = startDate
    if (userDateQuery && userTimeQuery) {
      searchDate = DateTime.fromFormat(`${userDateQuery} ${userTimeQuery}:00`, "dd / MM / yyyy HH:mm")
      if (searchDate <= minDate) {
        searchDate = minDate
      }
      if (searchDate.startOf("day").toMillis() === minDate.startOf("day").toMillis()) {
        stateMinTime = minDate
      }
    }

    this.state = {
      q: querystring,
      previousFlights: [],
      flights: null,
      currentPageJson: currentPageJson,
      direction: direction,
      ajaxSpinnerActive: true,
      ajaxSpinnerTransparent: false,
      pageType: pageType,
      currentUrl: currentUrl,
      searchDate: searchDate,
      minDate: minDate,
      datepickerOpen: false,
      minTime: stateMinTime,
      maxTime: maxTime,
      otherDaysMinTime: minTime,
      startDate: startDate,
      inputFocus: "blur",
      tabIcons: tabIcons,
    }

    this.search(direction, querystring, searchDate, props.language)
  }

  componentDidUpdate() {
    // waits until paint is done
    requestAnimationFrame(() => {
      stickyDatepicker()
    })
  }

  flightFilter = (flight, beforeDate) => {
    const date = flight.Date
    const time = flight.ExpectedTime
    const dateTime = DateTime.fromFormat(`${date} ${time}`, "dd-MM-yyyy HH:mm")
    if (dateTime < beforeDate) {
      return true
    }
    return false
  }

  search = async (direction, query, datetime, language) => {
    const userQuery = query && query.length >= 2 ? query : "*:*"
    const dt = datetime < this.state.startDate ? this.state.startDate : datetime
    const zone = "Europe/Copenhagen"
    const cphTime = dt.setZone(zone, { keepLocalTime: true }) // set zone to copenhagen and keep local time, which is already cph time
    const start = cphTime.minus({ days: 1 }).toUTC() // convert to UTC which is what Solr expects
    const end = cphTime.plus({ days: 2 }).toUTC() // convert to UTC which is what Solr expects
    const data = { direction: direction, query: userQuery ?? "", startDateTime: start, endDateTime: end, language: language }
    const response = await endpoints.getFlightInfoTable(data)
    let flights = []
    let previousFlights = []
    if (response && response.data) {
      flights = response.data
    }
    if (flights.length > 0) {
      if (this.state.minDate < datetime) {
        const filteredFlights = flights.filter((flight) => this.flightFilter(flight, this.state.searchDate))
        const remainingFlights = flights.filter((flight) => !this.flightFilter(flight, this.state.searchDate))

        previousFlights = filteredFlights
        flights = remainingFlights
      }
      flights = flights?.filter((flight) => {
        const beforeDate = this.state.searchDate.plus({ days: 2 })
        return this.flightFilter(flight, beforeDate)
      })
    }
    this.setState({ flights: flights, previousFlights: previousFlights, ajaxSpinnerActive: false })
  }

  switchTabs(type) {
    if (type !== this.state.pageType) {
      let contentId = ""
      this.setState(
        (prevState) => {
          switch (type) {
            case types.DEPARTURES:
              contentId = this.props.departuresContentId
              return this.getTabSwitchData(type)
            case types.ARRIVALS:
              contentId = this.props.arrivalsContentId
              return this.getTabSwitchData(type)
            default:
              return
          }
        },
        () => {
          this.search(this.state.direction, this.state.q, this.state.searchDate, this.props.language)
          this.updatePageTitle(contentId)
          this.updateUrl(type)
        },
      )
    }
  }

  getTabSwitchData(type) {
    return {
      ajaxSpinnerActive: true,
      pageType: type,
      direction: type === types.ARRIVALS ? "A" : "D",
      currentUrl: this.getCurrentUrl(type),
    }
  }

  getCurrentUrl(type) {
    switch (type) {
      case types.DEPARTURES:
        return this.state.currentPageJson.departuresPage
      case types.ARRIVALS:
        return this.state.currentPageJson.arrivalsPage
      default:
        return ""
    }
  }

  updatePageTitle(contentLink) {
    axios
      .get(`${this.props.dataUrl}/GetPageTitle?contentLink=${contentLink}`)
      .then((res) => {
        if (res.data) {
          document.title = res.data
          this.setState({ pageTitle: res.data })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  updateUrl(type) {
    let url = this.getCurrentUrl(type)
    let search = window.location.search
    let fullUrl = url + search
    window.history.replaceState({ path: fullUrl }, "", fullUrl)
  }

  handleInput = (event) => {
    const name = event.target.name
    const value = event.target.value
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.search(this.state.direction, this.state.q, this.state.searchDate, this.props.language)
        setQueryStringValue(name, value)
      },
    )
  }

  handleDateChange = (dateInput) => {
    this.setState(
      (prevState) => {
        const date = DateTime.fromJSDate(dateInput)
        const startOfMinDate = prevState.minDate.startOf("day")
        const startOfNewDate = date.startOf("day")
        if (startOfMinDate.toMillis() === startOfNewDate.toMillis()) {
          if (date <= prevState.minDate) {
            return { searchDate: prevState.minDate, minTime: prevState.minDate }
          }
          return { searchDate: date, minTime: prevState.minDate }
        } else {
          return { searchDate: date, minTime: prevState.otherDaysMinTime }
        }
      },
      () => {
        this.search(this.state.direction, this.state.q, this.state.searchDate, this.props.language)
        const date = this.state.searchDate.toFormat("dd / MM / yyyy")
        const time = this.state.searchDate.toFormat("HH")
        setQueryStringValue("date", date)
        setQueryStringValue("time", time)
      },
    )
  }

  handleDatepicker = (calendar) => {
    const openState = calendar.state.open
    calendar.setOpen(!openState)
    this.setState({ datepickerOpen: !this.state.datepickerOpen })
  }

  closeDatepicker = () => {
    this.setState({ datepickerOpen: false })
  }

  handleOutsideClick = (calendar) => {
    calendar.setOpen(false)
    this.setState({ datepickerOpen: false })
  }

  handlePrevDate = () => {
    const currentDate = this.state.searchDate
    let newDate = currentDate.minus({ days: 1 })
    if (newDate <= this.state.minDate) {
      newDate = this.state.minDate
    }
    this.handleDateChange(newDate.toJSDate())
  }

  handleNextDate = () => {
    const currentDate = this.state.searchDate
    const newDate = currentDate.plus({ days: 1 })
    this.handleDateChange(newDate.toJSDate())
  }

  getHeadlineWidth = (headline) => {
    const charPixelLength = 15.5
    return headline.length * charPixelLength
  }

  scrollIntoView = () => {
    let flightSection = null
    if (isMobile) {
      flightSection = document.getElementsByClassName("deck-flights")[0]
    } else {
      flightSection = document.getElementById("FlightSection")
    }
    if (flightSection) {
      flightSection.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  handleEscapeClose = (calendar) => {
    calendar.setOpen(false)
  }

  render() {
    const CustomInput = forwardRef(({ value }, ref) => (
      <button
        className={"react-datepicker-ignore-onclickoutside datepicker-label"}
        data-active-date={value}
        onClick={() => this.handleDatepicker(this.calendar)}
        ref={ref}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            this.handleDatepicker(this.calendar)
          }
          if (e.key === "Escape") {
            e.preventDefault()
            this.handleEscapeClose(this.calendar)
          }
        }}
        tabIndex={0}
      >
        {value}
      </button>
    ))
    CustomInput.displayName = "CustomInput"

    const CustomInputSticky = forwardRef(({ value }, ref) => (
      <button
        className={"react-datepicker-ignore-onclickoutside datepicker-label"}
        data-active-date={value}
        onClick={() => this.handleDatepicker(this.stickyCalendar)}
        ref={ref}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            this.handleDatepicker(this.stickyCalendar)
          }
          if (e.key === "Escape") {
            e.preventDefault()
            this.handleEscapeClose(this.stickyCalendar)
          }
        }}
        tabIndex={0}
      >
        {value}
      </button>
    ))
    CustomInputSticky.displayName = "CustomInputSticky"

    let mobileHeadline = ""
    let headline = ""
    if (isMobile) {
      if (this.state.pageType === types.DEPARTURES && this.state.currentPageJson.headlineMobileDepartures) {
        mobileHeadline = <h1 className="headline-md">{this.state.currentPageJson.headlineMobileDepartures}</h1>
      } else if (this.state.pageType === types.ARRIVALS && this.state.currentPageJson.headlineMobileArrivals) {
        mobileHeadline = <h1 className="headline-md">{this.state.currentPageJson.headlineMobileArrivals}</h1>
      }
    } else {
      let headlineWidth = 0
      if (this.state.currentPageJson.headlineDepartures) {
        headlineWidth = this.getHeadlineWidth(this.state.currentPageJson.headlineDepartures)
      }
      if (this.state.currentPageJson.headlineArrivals) {
        const tempWidth = this.getHeadlineWidth(this.state.currentPageJson.headlineArrivals)
        headlineWidth = tempWidth >= headlineWidth ? tempWidth : headlineWidth
      }

      const headlineStyle = { width: `${headlineWidth}px` }
      if (this.state.pageType === types.DEPARTURES && this.state.currentPageJson.headlineDepartures) {
        headline = (
          <h1 className="headline-md" style={headlineStyle}>
            {this.state.currentPageJson.headlineDepartures}
          </h1>
        )
      } else if (this.state.pageType === types.ARRIVALS && this.state.currentPageJson.headlineArrivals) {
        headline = (
          <h1 className="headline-md" style={headlineStyle}>
            {this.state.currentPageJson.headlineArrivals}
          </h1>
        )
      }
    }

    const chooseDayAriaLabelPrefix = this.state.currentPageJson.chooseDayAriaLabelPrefix || this.props.language == "da" ? "Vælg" : "Choose"
    const nextMonthAriaLabel = this.state.currentPageJson.nextMonthAriaLabel || this.props.language == "da" ? "Gå en måned frem" : "Next month"
    const previousMonthAriaLabel =
      this.state.currentPageJson.previousMonthAriaLabel || this.props.language == "da" ? "Gå en måned tilbage" : "Previous month"

    const departuresTabIcon = (
      <Svg iconName={this.state.tabIcons.departuresTabIcon ? this.state.tabIcons.departuresTabIcon : "planetakeoff"} isDecorative={true} />
    )
    const arrivalsTabIcon = (
      <Svg iconName={this.state.tabIcons.arrivalsTabIcon ? this.state.tabIcons.arrivalsTabIcon : "planelanding"} isDecorative={true} />
    )

    const isSameDay = this.state.minDate.startOf("day").toMillis() === this.state.searchDate.startOf("day").toMillis()

    return (
      <React.Fragment>
        <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
        <section className="deck deck--margin-bottom deck-flights">
          <div className="flights" id="FlightSection">
            <div className="flightHeaderContainer">
              <header id="flightHeader" className="flights__header">
                {mobileHeadline}
                <div className="form flights__header__form">
                  <div className="w--wider flights__header__form__inner-wrapper">
                    {headline}
                    <div className="form__section">
                      <div className="form__section__inner">
                        <div className="form__field form__field--text form__field--text-search  form__field--text--no-label">
                          <span className="form__valid"></span>
                          <input
                            className={`form__item ${isIOS ? "ios" : ""} ${this.state.inputFocus}`}
                            name="q"
                            id="searchTextbox"
                            type="text"
                            autoComplete="off"
                            value={this.state.q}
                            onChange={(e) => this.handleInput(e)}
                            placeholder={this.state.currentPageJson.queryPlaceholderText}
                            onFocus={() => this.setState({ inputFocus: "focus" })}
                            onBlur={() => this.setState({ inputFocus: "blur" })}
                          />
                          <button data-arrival-departures-search-button="data-arrival-departures-search-button" tabIndex={-1}>
                            <Svg iconName={"search"} isDecorative={true} />
                          </button>
                        </div>
                      </div>
                    </div>
                    {!isMobile ? (
                      <div className={`dateselect ${this.state.datepickerOpen ? "datepicker-open" : ""}`}>
                        <DatePicker
                          ref={(r) => (this.calendar = r)}
                          selected={this.state.searchDate.toJSDate()}
                          onChange={(date) => this.handleDateChange(date)}
                          showTimeSelect={true}
                          dateFormat="dd. MMM yyyy"
                          minDate={this.state.minDate.toJSDate()}
                          minTime={this.state.minTime.toJSDate()}
                          maxTime={this.state.maxTime.toJSDate()}
                          locale={this.props.language === "en" ? enGB : da}
                          customInput={<CustomInput calendar={this.calendar} />}
                          timeCaption={this.state.currentPageJson.datepickerTimeLabel || "Tidspunkt"}
                          timeIntervals={60}
                          onClickOutside={() => this.handleOutsideClick(this.calendar)}
                          onCalendarClose={this.closeDatepicker}
                          tabIndex={0}
                          chooseDayAriaLabelPrefix={chooseDayAriaLabelPrefix}
                          nextMonthAriaLabel={nextMonthAriaLabel}
                          previousMonthAriaLabel={previousMonthAriaLabel}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="tab-panes">
                  <nav className="tab-panes__arrivals-departures">
                    <div className="tab-panes__arrivals-departures__primary">
                      <div className="tab-panes__arrivals-departures__primary__inner">
                        <button
                          className={`button button--toggle ${this.state.pageType === types.DEPARTURES ? "is-active" : ""}`}
                          onClick={() => this.switchTabs(types.DEPARTURES)}
                          aria-selected={this.state.pageType === types.DEPARTURES}
                        >
                          {departuresTabIcon}
                          <span className="text">{this.state.currentPageJson.departureTabName}</span>
                        </button>
                        <button
                          className={`button button--toggle ${this.state.pageType === types.ARRIVALS ? "is-active" : ""}`}
                          onClick={() => this.switchTabs(types.ARRIVALS)}
                          aria-selected={this.state.pageType === types.ARRIVALS}
                        >
                          {arrivalsTabIcon}
                          <span className="text">{this.state.currentPageJson.arrivalTabName}</span>
                        </button>
                      </div>
                    </div>
                  </nav>
                </div>
              </header>
            </div>
            <div className="mobile-datepicker-container">
              <div className="mobile-datepicker" style={{ display: !isMobile ? "none" : null }} data-is-mobile={isMobile}>
                <div
                  role="button"
                  className={`date-arrow prev-date ${isSameDay ? "arrow-disabled" : ""}`}
                  onClick={isSameDay ? undefined : () => this.handlePrevDate()}
                  onKeyDown={(e) => {
                    if ((e.key === "Enter" || e.key === " ") && !isSameDay) {
                      e.preventDefault()
                      this.handlePrevDate()
                    }
                  }}
                  tabIndex={isSameDay ? -1 : 0}
                  aria-label={this.props.language === "da" ? "Forrige dato" : "Previous date"}
                ></div>
                <div className={`dateselect ${this.state.datepickerOpen ? "datepicker-open" : ""}`}>
                  <DatePicker
                    ref={(r) => (this.stickyCalendar = r)}
                    selected={this.state.searchDate.toJSDate()}
                    onChange={(date) => this.handleDateChange(date)}
                    showTimeSelect={isMobile ? false : true}
                    dateFormat="d. MMMM"
                    minDate={this.state.minDate.toJSDate()}
                    minTime={this.state.minTime.toJSDate()}
                    maxTime={this.state.maxTime.toJSDate()}
                    locale={this.props.language === "en" ? enGB : da}
                    customInput={<CustomInputSticky calendar={this.stickyCalendar} />}
                    timeCaption={this.state.currentPageJson.datepickerTimeLabel || "Tidspunkt"}
                    timeIntervals={60}
                    onClickOutside={() => this.handleOutsideClick(this.stickyCalendar)}
                    onCalendarClose={this.closeDatepicker}
                    tabIndex={0}
                    chooseDayAriaLabelPrefix={chooseDayAriaLabelPrefix}
                    nextMonthAriaLabel={nextMonthAriaLabel}
                    previousMonthAriaLabel={previousMonthAriaLabel}
                  />
                </div>
                <div
                  role="button"
                  className="date-arrow next-date"
                  onClick={() => this.handleNextDate()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault()
                      this.handleNextDate()
                    }
                  }}
                  aria-label={this.props.language === "da" ? "Næste dato" : "Next date"}
                  tabIndex={0}
                ></div>
              </div>
            </div>
            <FlightsTable
              {...this.state.currentPageJson}
              language={this.props.language}
              flightLandingPageExists={this.props.flightLandingPageExists}
              currentUrl={this.state.currentUrl}
              flights={this.state.flights}
              previousFlights={this.state.previousFlights}
              direction={this.state.direction}
              scrollIntoView={this.scrollIntoView}
            />
          </div>
        </section>
      </React.Fragment>
    )
  }
}
